import { type AmplifyError, useAuth } from '@backoffice-frontend/authentication'
import { useMoiaSuccessNotification } from '@backoffice-frontend/patterns'
import { updateMFAPreference, verifyTOTPSetup } from 'aws-amplify/auth'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { MFARegistrationView } from './MFARegistrationView'

export const MFASwitchView = () => {
  const { checkAuthState } = useAuth()
  const [error, setError] = useState<string>()
  const [validationToken, setValidationToken] = useState('')
  const { t } = useTranslation()
  const { enqueueMoiaSuccessNotification } = useMoiaSuccessNotification()

  const handleTokenVerifyClick = async () => {
    try {
      await verifyTOTPSetup({ code: validationToken })
      await updateMFAPreference({ totp: 'PREFERRED' })
      await checkAuthState()
      enqueueMoiaSuccessNotification(
        t('authenticatedAppView_mfaEnabledSuccess'),
      )
    } catch (_error) {
      const error = _error as AmplifyError
      switch (error.name) {
        case 'InvalidParameterException':
          return setError(t('authenticatedAppView_mfaCodeInvalidCharacter'))
        case 'VerifySoftwareTokenException':
          return setError(t('authenticatedAppView_mfaCodeInvalidCode'))
        default:
          return setError(
            error.message ?? t('authenticatedAppView_mfaCodeError'),
          )
      }
    }
  }

  return (
    <MFARegistrationView
      setValidationToken={setValidationToken}
      handleTokenVerifyClick={handleTokenVerifyClick}
      error={error}
    />
  )
}
